import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { AlertService } from './alertservice';
import { Observable, throwError } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { CbtserviceService } from '../services/cbtservice.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { UserauthenticationserviceService } from '../services/userauthenticationservice.service';
@Injectable()
export class AlertsInterceptor implements HttpInterceptor {

  constructor( private cbtservice : CbtserviceService, private router: Router,private notification :AlertService, private injector: Injector)  {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(            
      catchError((error : HttpErrorResponse) => {   
        const skip401LogoutRedirect = error.status === 401 && this.shouldSkip401LogoutRedirect();
        //if its not one of the exam requests that we don't want to keep retrying, OR its not a gateway timeout and its not a seamless scaling error
        if(!skip401LogoutRedirect && !request.headers.has('skip_error_handler_interceptor')){
          this.cbtservice.showHttpError(error);
        }
        if (error.status === 401 && !skip401LogoutRedirect) {//unauthorized
          this.logUserOut();
        }

        return throwError(error);
      })
    );

  }

  private shouldSkip401LogoutRedirect(): boolean {
    const userauth = this.injector.get(UserauthenticationserviceService);
    if (userauth.loggedOut) {
      return true;
    }
    const path = this.router.url.split('?')[0];
    return path === '/logout' || path === '/login' || path.startsWith('/access/login');
  }

  private logUserOut() {
    const userauth = this.injector.get(UserauthenticationserviceService);
    userauth.loggedOut = true;
    this.router.navigate(['/logout'], { queryParams: { unauthorized: true, stayinseb: 1 } });
  }
}
